export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14812.2c3ec117.jpg";